import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import imgCancelapp from "../../../images/Cancelapp.png";
import imgNcheck from "../../../images/ncheck.svg";
import imgWarning from "../../../images/warning.png";
import "./helper.scss";
import moment from "moment";

const MySwal = withReactContent(Swal);

export const getAlertPopUp = (custom) => {
  MySwal.fire({
    iconHtml: `<img src=${custom.error ? imgWarning : imgNcheck} />`,
    toast: true,
    position: "center",
    customClass: `custom-alert-popup ${custom.error ? " alert-error" : " alert-success"}`,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: `<img src=${imgCancelapp} />`,
    cancelButtonColor: "#ffff",
    timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
    ...custom,
  }).then((result) => { });
};

export const handleApiResonseErrors = (errors) => {
  if (errors) {
    for (var key in errors) {
      if (errors.hasOwnProperty(key)) {
        return errors[key][0];
      }
    }
  }
};


export const getFullMonthName = (shortMonth) => {
  const date = new Date(`${shortMonth} 1, 2020`);
  const options = { month: 'long' };
  return new Intl.DateTimeFormat('en-US', options).format(date);
}

export const dateFormat = 'MM/DD/YYYY';

export const dateFormatter = (date) => {
  return moment(date).format(dateFormat)
}

export const flattenValidationErrors = (errors) => {
  const result = {};

  for (const key in errors) {
    if (Array.isArray(errors[key]) && errors[key].length > 0) {
      result[key] = errors[key][0];
    }
  }
  return result;
}
export const maskNumber = (number) => {
  if (!number || typeof number !== 'string') {
    return '';
  }
  return number.slice(0, -4).replace(/\d/g, '*') + number.slice(-4);
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== 'string' || phoneNumber.length !== 10) {
    return '';
  }
  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6);
  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};

export const formatCurrency = (number) => {
  if (typeof number === 'string') {
    number = parseFloat(number);
  }
  if (isNaN(number)) {
    return '';
  }
  return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatNumberWithSpaces = (number) => {
  if (!number || typeof number !== 'string') {
    number = number.toString();
  }
  return number.replace(/(\d{4})(?=\d)/g, '$1 ');
};

// esign helpers
export const getPdfUrl = (url, signerType) => {
  let pdfUrl;
  try {
    if (signerType) {
      pdfUrl = `${url}-${signerType}/signed`;
    } else {
      pdfUrl = `${url}/signed`;
    }
  } catch {
    pdfUrl = url;
  }
  return pdfUrl;
};

// Button styles
export const startButtonStyles = {
  position: "absolute",
  right: "6px",
  top: "0px",
  cursor: "pointer",
  background: "#4C70EF",
  border: "none",
  zIndex: 10,
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "500",
  padding: "0 12px",
  height: "24px",
  lineHeight: "0",
  borderRadius: "4px",
  boxShadow: "0px 6px 12px -2px rgba(48, 125, 246, 0.28)",
};

const startButtonAttributes = {
  id: "startButton",
  type: "button",
  innerText: "Start",
};

// arrow styles
export const arrowStyles = {
  position: "absolute",
  right: "72px",
  width: "14px",
  height: "14px",
  background: "#ffc233",
  transform: "rotate(45deg)",
  visibility: "hidden",
  zIndex: 99,
};

export const arrowAttributes = {
  className: "pdf-arrow",
};

// signature styles

const signatureButtonStyles = {
  position: "absolute",
  right: "23px",
  background: "#ffc233",
  border: "none",
  color: "black",
  fontSize: "14px",
  fontWeight: "500",
  padding: "0 12px",
  height: "20.8px",
  lineHeight: "0",
  borderRadius: "0 4px 4px 0",
  visibility: "hidden",
  zIndex: 99,
  width: 'fit-content',
};

const signatureButtonAttributes = {
  type: "button",
  innerText: "Sign",
  className: "pdf-button",
};

const signatureImgStyles = {
  position: "absolute",
  maxWidth: "200px",
  maxHeight: "25px",
  zIndex: 99,
};

export function setStyles(element, styles) {
  for (const property in styles) {
    element.style[property] = styles[property];
  }
  return element;
}

export function setAttributes(element, attributes) {
  for (const property in attributes) {
    element[property] = attributes[property];
  }
  return element;
}

export function createStartButton() {
  const button = document.createElement("button");
  setStyles(button, startButtonStyles);
  setAttributes(button, startButtonAttributes);
  return button;
}

export function createArrow() {
  const arrow = document.createElement("div");
  setStyles(arrow, arrowStyles);
  setAttributes(arrow, arrowAttributes);
  return arrow;
}

export function createSignatureButton() {
  const button = document.createElement("button");
  setStyles(button, signatureButtonStyles);
  setAttributes(button, signatureButtonAttributes);
  return button;
}

export function createLoadingIndicator() {
  const loading = document.createElement("div");
  loading.className = "loader";
  loading.innerText = "Loading...";
  loading.style.position = "absolute";
  loading.style.display = "none";

  return loading;
}

export function createSignatureImg() {
  const img = document.createElement("img");
  setStyles(img, signatureImgStyles);
  img.className = "sign-img";
  return img;
}

export function updateSignatureImgSize(img, x, y) {
  const updateImgSize = () => {
    if (window.innerWidth < 400) {
      img.style.maxWidth = "80px";
      img.style.maxHeight = "8px";
      img.style.top = `${y+2}px`;
    } else if (window.innerWidth < 500 && window.innerWidth > 400) {
      img.style.maxWidth = "100px";
      img.style.maxHeight = "8px";
      img.style.top = `${y+4}px`;
    } else if (window.innerWidth < 700 && window.innerWidth > 500) {
      img.style.maxWidth = "110px";
      img.style.maxHeight = "12px";
      img.style.top = `${y+4}px`;
    } else if (window.innerWidth < 800 && window.innerWidth > 700) {
      img.style.maxWidth = "130px";
      img.style.maxHeight = "15px";
      img.style.top = `${y+6}px`;
    } else if (window.innerWidth < 900 && window.innerHeight > 800) {
      img.style.maxWidth = "150px";
      img.style.maxHeight = "17px";
    } else {
      img.style.maxWidth = "200px";
      img.style.maxHeight = "25px";
    }
  };

  updateImgSize();
  window.addEventListener("resize", updateImgSize);
}

export function updateTimeStamp(timestamp, x, y) {
  const updateTimestampSize = () => {
    if (window.innerWidth < 400) {
      timestamp.style.fontSize = "4px";
      timestamp.style.top = `${y + 12}px`;
    } else if (window.innerWidth < 500 && window.innerWidth > 400) {
      timestamp.style.fontSize = "4px";
      timestamp.style.top = `${y + 13}px`;
    } else if (window.innerWidth < 700 && window.innerWidth > 500) {
      timestamp.style.fontSize = "6px";
      timestamp.style.top = `${y + 18}px`;
    } else if (window.innerWidth < 800 && window.innerWidth > 700) {
      timestamp.style.fontSize = "7px";
      timestamp.style.top = `${y + 25}px`;
    } else if (window.innerWidth < 900 && window.innerHeight > 800) {
      timestamp.style.fontSize = "8px";
      timestamp.style.top = `${y + 27}px`;
    } else {
      timestamp.style.top = `${y + 31}px`;
    }
  };

  updateTimestampSize();
  window.addEventListener("resize", updateTimestampSize);
}

export function updateButton(button, width) {
  const updateButtonStyle = () => {
    if (window.innerWidth < 500) {
      button.style.left = `${width - 2}px`;
    } else {
      button.style.left = `${width}px`;
    }
  };

  updateButtonStyle();
  window.addEventListener("resize", updateButtonStyle);
}

export function toggleDisplay(element1, element2, displayValue) {
  if (element1.style.display === "none") {
    element1.style.display = displayValue;
  }

  if (element2.style.display === "none") {
    element2.style.display = displayValue;
  }
}

